export const PORTFOLIO_ASSISTANT_NAME = "Feilhann";
export const PORTFOLIO_ASSISTANT_ROLE = "Portfolio assistant";
export const PORTFOLIO_ASSISTANT_LABEL = `${PORTFOLIO_ASSISTANT_NAME} portfolio assistant`;
